module.exports = __webpack_public_path__ + "static/img/295.9fc37c80.png";